<template lang="pug">
BriqMultiselect(
  placeholder="Find existing customer"
  :options="customerOptions"
  @search-change="debounceSearchCustomers"
  track-by="Email"
  display="FullName"
  :loading="searching"
  :internal-search="false"
  @input="selectExisting"
  :bindObject="true"
  openDirection="bottom"
  )
  template(slot="singleLabel" slot-scope="props")
    div {{ props.option.Firstname }} {{ props.option.Lastname }}
  template(slot="option" slot-scope="props")
    .option
      .fullname.type-standard {{ props.option.Firstname }} {{ props.option.Lastname }}
      .email.type-small.mt-XXXS {{ props.option.Email }}
  template(slot="noOptions" slot-scope="props")
    span Type to search
</template>

<script>
import { debounce } from 'debounce'

// Howmany miliseconds until the API call triggers after typing in the search customer field
// =====================
const debounceTime = 500
// =====================

export default {
  name: 'FindCustomerInput',
  props: {},
  data() {
    return {
      searchResponse: null,
      searching: false,
      customerOptions: [],
      lastQuery: '',
    }
  },

  watch: {
    lastQuery(newval) {
      this.$emit('lastSearchQuery', newval)
    },
  },
  methods: {
    selectExisting(customer) {
      this.$emit('selected', customer)
    },
    debounceSearchCustomers: debounce(function(query) {
      if (!query || query === this.lastQuery) return
      this.lastQuery = query
      this.searching = true
      this.$apiClient
        .get(`customers/search?q=${query}`)
        .then(res => {
          this.searchResponse = res
          this.customerOptions = res.data
        })
        .catch(e => {
          this.$logError(e)
          this.$notifyError('Could not fetch customers')
        })
        .finally(() => (this.searching = false))
    }, debounceTime),
  },
}
</script>

<style lang="stylus">
.email
  color #798696
</style>
